import BaseApi from './BaseApi';
import { ApiPaths } from './ApiPaths';

/**
 * API for managing confirm identity information
 */
const create = () => {
    
    const api = BaseApi.create({ 
        timeout: 10 * 60 * 1000   // this should be long as the Trulioo call may take a while
    });

    const confirmIdentity = (target, extraAddresses, skipValidation) => {
        var payload;
        if (typeof skipValidation === "boolean") {
            payload = {
                target: target,
                extraAddresses: extraAddresses,
                skipValidation
            }
        } else {
                payload = {
                    target: target,
                    extraAddresses: extraAddresses
                }
            }
        return api.post(ApiPaths.CONFIRM_IDENTITY, payload);
    }

    const confirmIdentityDocuments = (target, imageType) => {
        var payload = {
            target: target,
            imageType: imageType
        }
        return api.post(ApiPaths.CONFIRM_IDENTITY_CONFIRMATION, payload);
    }

    const getConfirmDocumentStatus = (target) => {
        var payload = {
            target: target,
            extraAddresses: []
        }
        return api.post(ApiPaths.CONFIRM_IDENTITY_GET_CONFIRMATION, payload)
    }

    const uploadFile = (target, idType, isFront, imageData, progressFn) => {
        var payload = {
            target: target,
            imageType: idType,
            isFront: isFront,
            imageData: imageData
        }
        var progressInfo = {
            onUploadProgress: value => progressFn(value)
        }
        return api.upload(ApiPaths.CONFIRM_IDENTITY_UPLOAD_FILE, payload, progressInfo);
    }

    const getConfirmIdState = () => api.get(ApiPaths.CONFIRM_IDENTITY);

    const getDocVUrl = (isSpouse) => api.get(ApiPaths.GET_DOCV_URL(isSpouse));

    const getDocVStatus = (verificationSessionId) => api.get(ApiPaths.GET_DOCV_STATUS(verificationSessionId));

    const completeQrCodeVerification = (result, isSpouse, isCoupled) => {
        var payload = {
            result: result,
            isCoupled: isCoupled,
            isSpouse: isSpouse
        }
        return api.post(ApiPaths.COMPLETE_ID_VERIFICATION, payload);
    }

    // Return back a collection of functions
    return {
        confirmIdentity, uploadFile, confirmIdentityDocuments, getConfirmIdState, getConfirmDocumentStatus, getDocVUrl, getDocVStatus, completeQrCodeVerification
    }
}

// let's return back our create method as the default.
export default {
    create
}

